import { Injectable } from '@angular/core';

@Injectable()
export class OutboundDataSharingService {
    private selectedRowValue: string;

    constructor() { }

    // Setter Method
    public setWaveData(value: string) {
        this.selectedRowValue = value
    }

    // Getter Method
    public getWaveData() {
        return this.selectedRowValue
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/outbound/outbound-data-sharing.service.ts